<template>
  <div class="container">
    <div class="flowGroup">
      <small style="color:#1367a2;">IMvigor 210 Phase II, multicenter, open-label, 2-cohort trial design in locally advanced or metastatic urothelial carcinoma (n=429</small>
      <div class="caption" style="color:#1367a2;">Study Scheme</div>
      <div class="box">
        <div class="title">
          Key eligibility criteria
        </div>
        <ul class="list">
          <li>Locally advanced or metastatic UC</li>
          <li>Predominantly UC histology</li>
          <li>Tumor tissue for PD-L1 testing</li>
        </ul>
      </div>
    </div><!-- flow group end sub -->
    <div class="flowGroup">
      <div class="caption" style="color:#508fa8;">Cohort 1</div>
      <div class="box box-flow box-flow-right">
        <ul class="list">
          <li>
          No prior treatment for mUC <br/>(> 12 mo since peri-operative chemotherapy)
          </li>
          <li>ECOG PS 0-2</li>
          <li>
              Cisplatin ineligible per ≥ 1 of the following:<br/>
              -GFR &lt; 60 and > 30 mL/min<br/>
              (Cockcroft-Gault formula)<br/>
              - Grade ≥ 2 hearing lossa<br/>
              - Grade ≥ 2 peripheral neuropathy<br/>
              - ECOG PS 2
          </li>
        </ul>
      </div><!-- box end sub -->
      <div class="box box-flow box-flow-bottom">
        <div class="text">
          1L cisplatin ineligible(N = 119)
        </div>
      </div><!-- box end sub -->
      <div class="box box-flow">
        <div class="text">
          Atezolizumab<br/>
          1200 mg IV q3w<br/>
          until RECIST v1.1 PD
        </div>
      </div><!-- box end sub -->
    </div><!-- flow group end sub -->
    <div class="flowGroup">
      <div class="caption" style="color:#508fa8;">Cohort 2</div>
      <div class="box box-flow box-flow-right" style="padding-bottom:0;">
        <ul class="list">
          <li>Progression during or following platinum</li>
          <li>No maximum prior lines of therapy</li>
          <li>Creatinine Clearance ≥ 30 mL/min</li>
          <li>ECOG PS 0-1</li>
        </ul><!-- list end sub -->
        <div class="detail">
            PD-L1 testing per VENTANA SP142 IHC assay.<br/>
            ECOG PS, Eastern Cooperative Oncology Group performance status; GFR, glomerular filtration rate; <br/>
            IHC, immunohistochemistry; IV, intravenously;<br/>
            PD, progressive disease; q3w, every 3 weeks; RECIST v1.1,<br/>
             Response Evaluation Criteria in Solid Tumors.<br/>
            a Hearing loss of 25 dB at 2 contiguous frequencies.
        </div>
      </div><!-- box enb sub -->
      <div class="box box-flow box-flow-bottom">
        <div class="text">Platinum treated(N = 310)</div>
      </div><!-- box enb sub -->
      <div class="box box-flow">
        <div class="text">
            Atezolizumab<br/>
            1200 mg IV q3w<br/>
            until loss of clinical benefit
        </div>
      </div><!-- box enb sub -->
    </div><!-- flow group end sub -->
    <template>
      <router-link
      to="/step5-4" class="btn-next el-icon-arrow-right"></router-link>
    </template>
    <foot-component></foot-component>
  </div>
</template>

<script>
import footText from './footText'
export default {
  components: {
    'foot-component': footText
  }
}
</script>

<style scoped>
  .flowGroup {
    display:block;position:relative;
  }
  .flowGroup .caption {
    font-size:20px;font-weight:bold;letter-spacing:.5pt;
    padding:20px 0;
  }
  .flowGroup .box {
    background:#bb7d67;color:white;
    padding:10px;letter-spacing:.6pt;line-height:25px;
  }
  .flowGroup + .flowGroup .box {
    background:#84ccc9;box-sizing:border-box;
    vertical-align:top;
  }
  .flowGroup + .flowGroup + .flowGroup .box {
    background:#40aecf;
  }
  .flowGroup:first-child .box {width:80%;}
  .flowGroup .box-flow {
    width:50%;display:inline-block;
    margin-right:10%;
  }
  .flowGroup .box-flow.box-flow-right:after {
    content:"";display:block;
    width:50px;height:25px;
    background:url(../../assets/step5/arrow1-right.png) no-repeat;
    background-size:cover;
    position:absolute;left:53%;top:78px;
  }
  .flowGroup + .flowGroup + .flowGroup .box-flow.box-flow-right:after {
    background:url(../../assets/step5/arrow2-right.png) no-repeat;
    background-size:cover;
  }
  .flowGroup .box-flow.box-flow-bottom:after {
    content:"";display:block;
    width:25px;height:50px;
    background:url(../../assets/step5/arrow1-bottom.png) no-repeat;
    background-size:cover;
    position:absolute;right:45%;top:70px;
  }
  .flowGroup + .flowGroup + .flowGroup .box-flow.box-flow-bottom:after {
    background:url(../../assets/step5/arrow2-bottom.png) no-repeat;
    background-size:cover;
  }
  .flowGroup .box-flow + .box-flow {
    width:37%;position:absolute;right:0;top:68px;
    margin:0;text-align:center;
  }
  .flowGroup .box-flow:last-child {
    top:50%;
  }
  .flowGroup .box .title {
    padding-left:20px;font-size:18px;
    padding-top:10px;
  }
  .flowGroup .box .detail {
    background:white;color:#353535;
    padding:10px;box-sizing:content-box;
    width:106%;position:relative;left:-3%;
    font-size:14px;line-height:18px;
    letter-spacing:.4pt;
  }
  a[class*="btn-"]{
    background:#1367a2;color:white;
  }

  @media(max-width:750px){
    .flowGroup {width:90%;margin:auto;}
    .flowGroup:first-child .box {
      box-sizing:border-box;
    }
    .flowGroup > * {
      width:100% !important;
      position:static !important;
      margin:10px 0 !important;
    }
    .flowGroup + .flowGroup .box {
      position:relative !important;top:0;
      margin-bottom:70px !important;
    }
    .flowGroup .box-flow {position:relative;}
    .flowGroup .box-flow:after {
      bottom:-65px;top:auto !important;
      background:url(../../assets/step5/arrow2-bottom.png) no-repeat !important;
      background-size:cover !important;
      width: 25px !important;height: 50px !important;
      left:45% !important;right:auto !important
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/step5/page4.vue